// import { EXPO_MANIFEST_EXTRA } from '../../../constants/index'
// import * as Amplitude from '../../../expo-analytics-amplitude'
import { logUtil } from 'packages/src'

let isInitialized

function initAnalyticsUtil () {
  try {
    if (isInitialized) {
      return
    }
    // Amplitude.initializeAsync(EXPO_MANIFEST_EXTRA.amplitudeApiKey)
    isInitialized = true
  } catch (error) {
    logUtil('').error(
      'initializing analytics failed: ',
      error
    )
  }
}

export {
  initAnalyticsUtil
}
